import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Formik } from 'formik';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Grid, Paper } from '@material-ui/core';
import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@material-ui/core/Tooltip';
import MailIcon from '@material-ui/icons/MailOutline';
import { CommonConfig } from '../../../config/common-config';
import PreviewModal from '../../../components/modal/previewModal';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import DownGrey from '../../../assets/down_grey.png';
import DownWhite from '../../../assets/down_white.png';
import PreGrey from '../../../assets/pre_grey.png';
import PreWhite from '../../../assets/pre_white.png';
import TabList from '../../../components/checklistTab/tabList';
import buttonDisable from '../../../components/disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';
import { setSelectedStageId } from '../../services/store/actions';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
    },

    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },

    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },

    pos: {
        marginBottom: 12,
    },

    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },

    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },

    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },

    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },

    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },

    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        minWidth: '300px',
        margin: '0 10px !important',
        background: '#800080',
    },

    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '8px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
        pointerEvents: 'none',
        borderRadius: '6px !important',
        border: 'none !important',
    },

    inlinebutton: {
        padding: '0',
        margin: '0',
        display: 'inline-flex',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
        },
    },

    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    toolTipFont: {
        fontFamily: 'Rubik !important',
        fontSize: '12px',
    },
}));

function StyledRadio(props) {
    const classes = useStyles();
    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function IMCFinalDocApproval() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch({});
    const [finaldraft, setFinalDraft] = useState({});
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const [successpop, setSuccessPop] = useState(false);
    const [ITRsuccess, setITRSuccess] = useState(false);
    const [TAXsuccess, setTAXSuccess] = useState(false);
    const [clientButton, setClientButton] = useState(false);
    const [ITRButton, setITRButton] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [URLValue, setURLValue] = useState('');
    const [ITRFoldername, setITRFoldername] = useState('');
    const [TAXFoldername, setTAXFoldername] = useState('');
    const [TAXFoldernameTax, setTAXFoldernameTax] = useState('');
    const [TAXFoldernameTaxPath, setTAXFoldernameTaxPath] = useState('');
    const [FileComputationDoc, setFileComputationDoc] = useState('');
    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [attachedFilename, setAttachedFilename] = useState('');
    const [AttachedITRAcknowledgementFilename, setAttachedITRAcknowledgementFilename] = useState('');
    const [filename, setFilename] = useState('');
    // const [filenameTax, setFilenameTax] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [uploadDisable, setUploadDisable] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [isDisable, setIsDisable] = useState(true);
    const [radioValue, setRadioValue] = useState('alreadypaid');
    const [OfflineURLValue, setOfflineURLValue] = useState('');
    const [offlineFilename, setOfflineFilename] = useState('');
    const [OfflineITRURLValue, setOfflineITRURLValue] = useState('');
    const [offlineITRFilename, setOfflineITRFilename] = useState('');
    const [ITRFilename, setITRFilename] = useState('');
    const [finalCompFile, setFinalCompFile] = useState('');
    const [transferredChallan, setTransferredChallan] = useState('');
    const [transChallanName, setTransChallanName] = useState('');
    const [fileUploadType, setFileUploadType] = useState('');
    const [visible, setVisible] = React.useState(false);
    const [downloadPath, setDownloadPath] = useState('');
    const [mailBtn, setMailBtn] = useState(false);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [paidTax, setPaidTax] = useState();
    const [ITRAckView, setITRAckView] = useState('');
    const [TaxAckView, setTaxAckView] = useState('');
    const [AttachedTaxAcknowledgementFilename, setAttachedTaxAcknowledgementFilename] = useState('');

    const handleClose = () => {
        setShowLoader(false);
        setHandleOpen(false);
    };

    const downloadFile = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${finaldraft && finaldraft.taxChalanOrAcknowledgement}`, {
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })
            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    const downloadITRFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })
            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    const downloadTransChallan = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })
            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/by-serviceId/${dbname}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                // console.log('responseIMCfromEM', response);
                const itrAcknowledgementfilename = response.data['itrAcknowledgement'];
                setITRAckView(itrAcknowledgementfilename);
                setAttachedITRAcknowledgementFilename(
                    itrAcknowledgementfilename.substring(itrAcknowledgementfilename.lastIndexOf('/') + 1)
                );
                setPaidTax(response.data.paidTax);
                const filename = response.data['taxChalanOrAcknowledgement'];
                setTaxAckView(filename);
                setAttachedTaxAcknowledgementFilename(filename.substring(filename.lastIndexOf('/') + 1));
                const transChallanFile = response.data['transferchallan'];
                setITRFilename(filename.substring(filename.lastIndexOf('/') + 1));
                setFinalDraft(response.data);
                setFinalCompFile(response.data['taxChalanOrAcknowledgement']);
                setRadioValue(response.data['payonline'] ? 'alreadypaid' : 'offline');
                setTAXFoldernameTax(filename.substring(filename.lastIndexOf('/') + 1));
                setTAXFoldernameTaxPath(response.data.taxChalanOrAcknowledgement);
                setFileComputationDoc(response.data.finalComputationDocument);
                setTransferredChallan(response.data.transferchallan);
                setTransChallanName(transChallanFile.substring(transChallanFile.lastIndexOf('/') + 1));
                // setPaidTax(response.data['paidTax']);
            })
            .catch(() => { });
    }, [userToken, ITRFoldername, TAXFoldername, URLValue, OfflineURLValue]);

    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(pdf)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setUploadDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e pdf');
                setIsDisable(true);
            }
        }
    };

    const fileUpload = (e) => {
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/${serviceIdValue}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                // console.log('fileUpload', response);
                if (response.data) {
                    if (fileUploadType === 'ITR') {
                        const ITRfilename = response.data;
                        setURLValue(response.data);
                        setAttachedFilename(filename);
                        setOfflineITRURLValue(response.data);
                        setOfflineITRFilename(filename);
                        setIsDisable(false);
                        setITRFoldername(ITRfilename.substring(ITRfilename.lastIndexOf('/') + 1));
                        setUploadSuccessfully('Uploaded a file successfully');
                        const ITRFoldername = response.data;
                        setTimeout(() => {
                            handleSave(ITRFoldername);
                        }, 5000);
                    } else if (fileUploadType === 'TAX') {
                        setOfflineURLValue(response.data);
                        setOfflineFilename(filename);
                        setIsDisable(false);
                        const Taxfilename = response.data;
                        setTAXFoldername(Taxfilename.substring(Taxfilename.lastIndexOf('/') + 1));
                        // setTAXFoldername(response.data);
                        setUploadSuccessfully('Uploaded a file successfully');
                        const TAXFoldername = response.data;
                        setTimeout(() => {
                            handleSave(TAXFoldername);
                        }, 3000);
                    }
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisable(true);
                }
            });
    };

    const handleClick = (val) => {
        setFileUploadType(val);
        setHandleOpen(true);
        setUploadSuccessfully('');
        setUploadDisable(true);
        setClearData('');
    };

    const handleITRFlied = () => {
        setShowLoader(true);
        const data = {
            serviceId: serviceIdValue,
            tennantName: imcNameSelected,
        };
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/send-email-with-attachment`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data === 'SUCCESS - Email Sent') {
                    setITRButton(true);
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setITRSuccess(true);
                    }, 1500);
                    setTimeout(() => {
                        setITRSuccess(false);
                    }, 3000);
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setErrorPop(true);
                    }, 1500);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const sendTaxChallanToClient = () => {
        setShowLoader(true);
        const data = {
            serviceId: serviceIdValue,
            tennantName: imcNameSelected,
        };
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/send-email-with-taxchallan`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data === 'SUCCESS - Email Sent') {
                    setClientButton(true);
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setTAXSuccess(true);
                    }, 1500);
                    setTimeout(() => {
                        setTAXSuccess(false);
                    }, 3000);
                }
            })
            .catch((error) => {
                setClientButton(true);
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setErrorPop(true);
                    }, 1500);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const closeDialog = () => {
        setHandleOpen(false);
        setIsfileInvalid('');
        setFilename(null);
    };

    const handleStatedChange = (e) => {
        setRadioValue(e.target.value);
    };

    const handleSave = (filename) => {
        setShowLoader(true);
        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            finalDocumentAndReports: {
                finalComputationDocument: FileComputationDoc,
                transferToAccount: finaldraft.transferToAccount,
                itrAcknowledgement:
                    paidTax === true
                        ? filename
                        : TAXFoldername || AttachedTaxAcknowledgementFilename || ITRFoldername.length > 1
                            ? filename
                            : '',
                taxChalanOrAcknowledgement: paidTax === true ? '' : filename,
                payonline: finaldraft.payonline,
                stage: finaldraft.stage,
                descriptionForInvoice: finaldraft.descriptionForInvoice,
                amountForInvoice: finaldraft.amountForInvoice,
                reports: finaldraft.reports,
                transferchallan: transferredChallan,
                paidTax: paidTax,
            },
        };
        axios
            .put(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/save-itr-ack/${imcNameSelected}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data === 'SUCCESS') {
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                    }, 1500);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setTimeout(() => {
                        closeDialog();
                    }, 500);
                }
                setMailBtn(true);
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setErrorPop(true);
                    }, 1500);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const handleNavigate = () => {
        setShowLoader(true);
        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            finalDocumentAndReports: {
                finalComputationDocument: FileComputationDoc,
                itrAcknowledgement: OfflineITRURLValue,
                taxChalanOrAcknowledgement: radioValue === 'alreadypaid' ? TAXFoldernameTaxPath : OfflineURLValue,
                transferToAccount: finaldraft.transferToAccount,
                payonline: finaldraft.payonline,
                stage: finaldraft.stage,
                descriptionForInvoice: finaldraft.descriptionForInvoice,
                amountForInvoice: finaldraft.amountForInvoice,
                reports: finaldraft.reports,
                paidTax: paidTax,
                transferchallan: transferredChallan,
            },
        };
        axios
            .put(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/itr-payment-computation/${imcNameSelected}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data === 'SUCCESS') {
                    userType.value = 'Reports';
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setSuccessPop(true);
                    }, 1500);
                    setTimeout(() => {
                        dispatch(setSelectedStageId(22));
                        userType.compFile = finalCompFile;
                        history.push({
                            pathname: '/menu/imc-reports',
                            state: { finalCompFile: finalCompFile, itrFile: URLValue, taxChallanFile: OfflineURLValue },
                        });
                    }, 3000);
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoader(true);
                    setTimeout(() => {
                        setShowLoader(false);
                        setErrorPop(true);
                    }, 1500);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadPath(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowLoader(true);
        setTimeout(() => {
            setShowLoader(false);
            setVisible(true);
        }, 1000);
    };

    const navigateBack = () => {
        history.push({
            pathname: '/menu/openservice',
        });
    };

    const useStylesBootstrap = makeStyles((theme) => ({
        arrow: {
            color: '#e5e5e5',
        },
        tooltip: {
            backgroundColor: '#e5e5e5',
            color: '#444',
        },
    }));

    function BootstrapTooltip(props) {
        const classes = useStylesBootstrap();
        return <Tooltip arrow placement="bottom" classes={classes} {...props} />;
    }

    return (
        <div>
            <TabList />
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? <SuccessPopUp open={successpop} showSuccess={successpop} title="Report generated successfully" /> : null}
            {ITRsuccess ? (
                <SuccessPopUp open={ITRsuccess} showSuccess={ITRsuccess} title="ITR Filed successfully, Email has been sent to client" />
            ) : null}
            {TAXsuccess ? (
                <SuccessPopUp open={TAXsuccess} showSuccess={TAXsuccess} title="TAX Challan has been sent to client Email" />
            ) : null}
            {errorpop ? <ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} /> : null}
            <Formik enableReinitialize>
                {(formik) => {
                    return (
                        <form onSubmit={formik.handleSubmit}>
                            <Card className={classes.root}>
                                <CardContent>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} className="main-container">
                                            <Typography className="final-doc-title">Tax Payment and Filing</Typography>
                                        </Grid>
                                        {paidTax === false ? (
                                            <Grid item xs={12} sm={12} className="text-center">
                                                <FormControl component="fieldset">
                                                    <RadioGroup
                                                        defaultValue="alreadypaid"
                                                        aria-label="aadhar"
                                                        name="customized-radios"
                                                        className="radio-option"
                                                        value={radioValue}
                                                        onChange={handleStatedChange}
                                                    >
                                                        <ul className={classes.inlineDisplay}>
                                                            <li>
                                                                <FormControlLabel
                                                                    value="alreadypaid"
                                                                    control={<StyledRadio />}
                                                                    label="Already Paid"
                                                                    disabled
                                                                />
                                                            </li>
                                                            <li>
                                                                <FormControlLabel
                                                                    value="offline"
                                                                    control={<StyledRadio />}
                                                                    label="Through Offline / Phone Call"
                                                                    disabled
                                                                />
                                                            </li>
                                                        </ul>
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                        ) : null}
                                        {radioValue === 'alreadypaid' ? (
                                            <Grid container spacing={3} className="final-doc-container">
                                                {paidTax === false ? (
                                                    <Grid item xs={12} sm={6}>
                                                        <Paper className="final-doc-card-grey">
                                                            <Grid container spacing={1} className="final-doc-subcontainer">
                                                                <Grid item xs={12} sm={12}>
                                                                    <Typography className="fd-card-title-grey">Tax Challan</Typography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6}>
                                                                    <div className="final-file-upload">
                                                                        <div className="file-name">
                                                                            {TAXFoldernameTax.substring(0, 15)}
                                                                            {TAXFoldernameTax.length > 15 ? '...' : ''}
                                                                        </div>
                                                                        {TAXFoldernameTax ? (
                                                                            <div className="file-icons">
                                                                                <span
                                                                                    onClick={() =>
                                                                                        handlePreviewModal(
                                                                                            finaldraft.taxChalanOrAcknowledgement
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Tooltip title="Preview">
                                                                                        <img src={PreGrey} alt="PreGrey" />
                                                                                    </Tooltip>
                                                                                </span>
                                                                                <Tooltip title="download">
                                                                                    <img
                                                                                        src={DownGrey}
                                                                                        alt="DownGrey"
                                                                                        onClick={downloadFile}
                                                                                    />
                                                                                </Tooltip>
                                                                            </div>
                                                                        ) : null}
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Paper>
                                                    </Grid>
                                                ) : null}
                                                <Grid item xs={12} sm={6}>
                                                    <Paper className="final-doc-card-blue">
                                                        <Grid container spacing={1} className="final-doc-subcontainer">
                                                            <Grid item xs={12} sm={12}>
                                                                <Typography className="fd-card-title-blue">ITR Acknowledgement</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <Button
                                                                    disabled={usertype === 'Other employee users'}
                                                                    variant="contained"
                                                                    className="btn-attach"
                                                                    onClick={() => handleClick('ITR')}
                                                                    disabled={buttonDisable(stageId, userType.value)}
                                                                >
                                                                    Attach Document<span style={{ color: '#ff0a047a' }}>*</span>
                                                                </Button>
                                                            </Grid>
                                                            {stageId === 21 ? (
                                                                <Grid item xs={12} sm={6}>
                                                                    {/* {AttachedITRAcknowledgementFilename ? (
                                                                        <div className="final-file-upload">
                                                                            <div className="file-name">
                                                                                {AttachedITRAcknowledgementFilename.substring(0, 15)}
                                                                                {AttachedITRAcknowledgementFilename.length > 15 ? '...' : ''}
                                                                            </div> */}

                                                                    {ITRFoldername ||
                                                                        AttachedITRAcknowledgementFilename ||
                                                                        offlineITRFilename ? (
                                                                            <div className="final-file-upload">
                                                                                <div className="file-name">
                                                                                    {/* {offlineITRFilename.substring(0, 15)}
                                                                                            {offlineITRFilename.length > 15 ? '...' : ''} */}

                                                                                    {ITRFoldername ||
                                                                                        AttachedITRAcknowledgementFilename.substring(0, 15)}
                                                                                    {ITRFoldername ||
                                                                                        AttachedITRAcknowledgementFilename.length > 15
                                                                                        ? '...'
                                                                                        : ''}
                                                                                </div>
                                                                                <div className="file-icons">
                                                                                    <span onClick={() => handlePreviewModal(URLValue)}>
                                                                                        <Tooltip title="Preview">
                                                                                            <img src={PreWhite} alt="PreWhite" />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                    <Tooltip title="Download">
                                                                                        <img
                                                                                            src={DownWhite}
                                                                                            alt="DownWhite"
                                                                                            onClick={() => downloadITRFile(URLValue)}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                </Grid>
                                                            ) : (
                                                                    <Grid item xs={12} sm={6}>
                                                                        {AttachedITRAcknowledgementFilename || offlineITRFilename ? (
                                                                            <div className="final-file-upload">
                                                                                <div className="file-name">
                                                                                    {AttachedITRAcknowledgementFilename &&
                                                                                        AttachedITRAcknowledgementFilename.substring(0, 15)}
                                                                                    {AttachedITRAcknowledgementFilename &&
                                                                                        AttachedITRAcknowledgementFilename.length > 15
                                                                                        ? '...'
                                                                                        : ''}
                                                                                </div>
                                                                                <div className="file-icons">
                                                                                    <span onClick={() => handlePreviewModal(ITRAckView)}>
                                                                                        <Tooltip title="Preview">
                                                                                            <img src={PreWhite} alt="PreWhite" />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                    <Tooltip title="Download">
                                                                                        <img
                                                                                            src={DownWhite}
                                                                                            alt="DownWhite"
                                                                                            onClick={() => downloadITRFile(ITRAckView)}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                    </Grid>
                                                                )}
                                                        </Grid>
                                                    </Paper>
                                                    {(AttachedITRAcknowledgementFilename &&
                                                        AttachedITRAcknowledgementFilename.length > 1) ||
                                                        (offlineITRFilename && mailBtn) ? (
                                                            <Button
                                                                startIcon={<MailIcon />}
                                                                variant="outlined"
                                                                color="primary"
                                                                size="small"
                                                                className="btn-email"
                                                                disabled={ITRButton || buttonDisable(stageId, userType.value)}
                                                                onClick={() => handleITRFlied()}
                                                            >
                                                                ITR Filed<span style={{ color: '#ff0a047a' }}>*</span>
                                                            </Button>
                                                        ) : null}
                                                </Grid>
                                            </Grid>
                                        ) : null}

                                        {radioValue === 'offline' ? (
                                            <Grid container spacing={3} className="final-doc-container">
                                                <Grid item xs={12} sm={12}>
                                                    <Paper className="final-doc-card-grey">
                                                        <Grid container spacing={1} className="final-doc-subcontainer">
                                                            <Grid item xs={12} sm={12}>
                                                                <Typography className="fd-card-title-grey">
                                                                    Transferred Challan / Acknowledgement
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={3}>
                                                                <div className="final-file-upload">
                                                                    <div className="file-name">
                                                                        {/* {transChallanName
                                                                            .substring(transChallanName.lastIndexOf('/') + 1)
                                                                            .substring(0, 15).length > 15
                                                                            ? '...'
                                                                            : ''}
                                                                        {transChallanName
                                                                            .substring(transChallanName.lastIndexOf('/') + 1)
                                                                            .substring(0, 15).length > 15
                                                                            ? '...'
                                                                            : ''} */}

                                                                        {transChallanName.substring(0, 15)}
                                                                        {transChallanName.length > 15 ? '...' : ''}
                                                                    </div>
                                                                    <div className="file-icons">
                                                                        <span onClick={() => handlePreviewModal(transferredChallan)}>
                                                                            <Tooltip title="Preview">
                                                                                <img src={PreGrey} alt="DownGrey" />
                                                                            </Tooltip>
                                                                        </span>
                                                                        {/* <span className="fileName" style={{ textAlign: 'start', marginRight: '12px' }}>{transChallanName}</span> */}
                                                                        <span onClick={() => downloadTransChallan(transferredChallan)}>
                                                                            <Tooltip title="download">
                                                                                <img src={DownGrey} alt="PreGrey" />
                                                                            </Tooltip>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Paper className="final-doc-card-blue">
                                                        <Grid container spacing={1} className="final-doc-subcontainer">
                                                            <Grid item xs={12} sm={12}>
                                                                <Typography className="fd-card-title-blue">Tax Challan</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <Button
                                                                    disabled={
                                                                        usertype === 'Other employee users' ||
                                                                        buttonDisable(stageId, userType.value)
                                                                    }
                                                                    variant="contained"
                                                                    className="btn-attach"
                                                                    onClick={() => handleClick('TAX')}
                                                                >
                                                                    Attach Document
                                                                </Button>
                                                            </Grid>

                                                            {stageId === 21 ? (
                                                                <Grid item xs={12} sm={6}>
                                                                    {TAXFoldername ||
                                                                        AttachedTaxAcknowledgementFilename ||
                                                                        offlineFilename ? (
                                                                            <div className="final-file-upload">
                                                                                <div className="file-name">
                                                                                    {/* {offlineFilename.substring(0, 15)}
                                                                                {offlineFilename.length > 15 ? '...' : ''} */}

                                                                                    {TAXFoldername ||
                                                                                        AttachedTaxAcknowledgementFilename.substring(0, 15)}
                                                                                    {TAXFoldername ||
                                                                                        AttachedTaxAcknowledgementFilename.length > 15
                                                                                        ? '...'
                                                                                        : ''}
                                                                                </div>
                                                                                <div className="file-icons">
                                                                                    <span onClick={() => handlePreviewModal(OfflineURLValue)}>
                                                                                        <Tooltip title="preview">
                                                                                            <img src={PreWhite} alt="PreWhite" />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                    <span>
                                                                                        <Tooltip title="download">
                                                                                            <img
                                                                                                src={DownWhite}
                                                                                                alt="DownWhite"
                                                                                                onClick={() => downloadITRFile(OfflineURLValue)}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                </Grid>
                                                            ) : (
                                                                    <Grid item xs={12} sm={6}>
                                                                        {TAXFoldernameTax ? (
                                                                            <div className="final-file-upload">
                                                                                <div className="file-name">
                                                                                    {TAXFoldernameTax.substring(0, 15)}
                                                                                    {TAXFoldernameTax.length > 15 ? '...' : ''}
                                                                                </div>
                                                                                <div className="file-icons">
                                                                                    <span onClick={() => handlePreviewModal(TaxAckView)}>
                                                                                        <Tooltip title="preview">
                                                                                            <img src={PreWhite} alt="PreWhite" />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                    <span>
                                                                                        <Tooltip title="download">
                                                                                            <img
                                                                                                src={DownWhite}
                                                                                                alt="DownWhite"
                                                                                                onClick={() => downloadITRFile(TaxAckView)}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                    </Grid>
                                                                )}
                                                        </Grid>
                                                    </Paper>

                                                    {(AttachedTaxAcknowledgementFilename &&
                                                        AttachedTaxAcknowledgementFilename.length > 1) ||
                                                        (offlineFilename && mailBtn) ? (
                                                            <Button
                                                                startIcon={<MailIcon />}
                                                                variant="outlined"
                                                                color="primary"
                                                                size="small"
                                                                className="btn-email"
                                                                onClick={() => sendTaxChallanToClient()}
                                                                disabled={clientButton || buttonDisable(stageId, userType.value)}
                                                            >
                                                                Send to Client
                                                        </Button>
                                                        ) : null}
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Paper className="final-doc-card-blue">
                                                        <Grid container spacing={1} className="final-doc-subcontainer">
                                                            <Grid item xs={12} sm={12}>
                                                                <Typography className="fd-card-title-blue">ITR Acknowledgement</Typography>
                                                            </Grid>
                                                            {TAXFoldername ||
                                                                (AttachedTaxAcknowledgementFilename &&
                                                                    AttachedTaxAcknowledgementFilename.length > 0) ? (
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Button
                                                                            disabled={
                                                                                usertype === 'Other employee users' ||
                                                                                buttonDisable(stageId, userType.value)
                                                                            }
                                                                            variant="contained"
                                                                            className="btn-attach"
                                                                            onClick={() => handleClick('ITR')}
                                                                        >
                                                                            Attach Document
                                                                    </Button>
                                                                    </Grid>
                                                                ) : paidTax === false ? (
                                                                    <BootstrapTooltip
                                                                        title={
                                                                            <React.Fragment>
                                                                                <Typography color="inherit" className={classes.toolTipFont}>
                                                                                    First attach Tax Challan and then ITR Acknowledgement
                                                                            </Typography>
                                                                            </React.Fragment>
                                                                        }
                                                                    >
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Button
                                                                                disabled={
                                                                                    usertype === 'Other employee users' ||
                                                                                    buttonDisable(stageId, userType.value)
                                                                                }
                                                                                variant="contained"
                                                                                className="greyclr"
                                                                            // onClick={() => handleClick('ITR')}
                                                                            >
                                                                                Attach Document
                                                                        </Button>
                                                                        </Grid>
                                                                    </BootstrapTooltip>
                                                                ) : (
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Button
                                                                                disabled={
                                                                                    usertype === 'Other employee users' ||
                                                                                    buttonDisable(stageId, userType.value)
                                                                                }
                                                                                variant="contained"
                                                                                className="btn-attach"
                                                                                onClick={() => handleClick('ITR')}
                                                                            >
                                                                                Attach Document
                                                                    </Button>
                                                                        </Grid>
                                                                    )}

                                                            {stageId === 21 ? (
                                                                <Grid item xs={12} sm={6}>
                                                                    {ITRFoldername ||
                                                                        AttachedITRAcknowledgementFilename ||
                                                                        offlineITRFilename ? (
                                                                            <div className="final-file-upload">
                                                                                <div className="file-name">
                                                                                    {/* {offlineITRFilename.substring(0, 15)}
                                                                                            {offlineITRFilename.length > 15 ? '...' : ''} */}

                                                                                    {ITRFoldername ||
                                                                                        AttachedITRAcknowledgementFilename.substring(0, 15)}
                                                                                    {ITRFoldername ||
                                                                                        AttachedITRAcknowledgementFilename.length > 15
                                                                                        ? '...'
                                                                                        : ''}
                                                                                </div>
                                                                                <div className="file-icons">
                                                                                    <span
                                                                                        onClick={() => handlePreviewModal(OfflineITRURLValue)}
                                                                                    >
                                                                                        <Tooltip title="preview">
                                                                                            <img src={PreWhite} alt="PreWhite" />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                    <span>
                                                                                        <Tooltip title="download">
                                                                                            <img
                                                                                                src={DownWhite}
                                                                                                alt="DownWhite"
                                                                                                onClick={() =>
                                                                                                    downloadITRFile(OfflineITRURLValue)
                                                                                                }
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                </Grid>
                                                            ) : (
                                                                    <Grid item xs={12} sm={6}>
                                                                        {AttachedITRAcknowledgementFilename ? (
                                                                            <div className="final-file-upload">
                                                                                <div className="file-name">
                                                                                    {AttachedITRAcknowledgementFilename.substring(0, 15)}
                                                                                    {AttachedITRAcknowledgementFilename.length > 15
                                                                                        ? '...'
                                                                                        : ''}
                                                                                </div>
                                                                                <div className="file-icons">
                                                                                    <span onClick={() => handlePreviewModal(ITRAckView)}>
                                                                                        <Tooltip title="preview">
                                                                                            <img src={PreWhite} alt="PreWhite" />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                    <span>
                                                                                        <Tooltip title="download">
                                                                                            <img
                                                                                                src={DownWhite}
                                                                                                alt="DownWhite"
                                                                                                onClick={() => downloadITRFile(ITRAckView)}
                                                                                            />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        ) : null}
                                                                    </Grid>
                                                                )}
                                                        </Grid>
                                                    </Paper>
                                                    {(AttachedITRAcknowledgementFilename &&
                                                        AttachedITRAcknowledgementFilename.length > 1) ||
                                                        (offlineITRFilename && mailBtn) ? (
                                                            <Button
                                                                startIcon={<MailIcon />}
                                                                variant="outlined"
                                                                color="primary"
                                                                size="small"
                                                                className="btn-email"
                                                                onClick={() => handleITRFlied()}
                                                                disabled={ITRButton || buttonDisable(stageId, userType.value)}
                                                            >
                                                                ITR Filed<span style={{ color: '#ff0a047a' }}>*</span>
                                                            </Button>
                                                        ) : (
                                                            ''
                                                        )}
                                                </Grid>
                                            </Grid>
                                        ) : null}
                                        <Grid item xs={12} sm={12} className="text-center">
                                            <FormControl fullWidth className="mt50 mb50 btn-center">
                                                <PreviewModal
                                                    fileSource={downloadPath}
                                                    visibleClose={visible}
                                                    handleModalClose={handleModalClose}
                                                />
                                                <Dialog
                                                    onClose={handleClose}
                                                    PaperProps={{
                                                        className: 'QandADailogBox',
                                                        style: { padding: '20px' },
                                                    }}
                                                    aria-labelledby="form-dialog-title"
                                                    open={handleOpen}
                                                    clear={clearData}
                                                >
                                                    <DialogTitle id="form-dialog-title">Upload File</DialogTitle>
                                                    <DialogContent
                                                        style={{
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                            <i className="btnIcon">
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </i>{' '}
                                                            Add File
                                                            <input
                                                                onChange={(e) => isFileUpload(e, e.target.files)}
                                                                type="file"
                                                                style={{
                                                                    display: 'none',
                                                                }}
                                                                accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                            />
                                                        </Button>
                                                        {/* {!isfileInvalid && filename ? ( */}
                                                        {filename ? (
                                                            <p className="fileName">
                                                                {filename.substring(0, 15)}
                                                                {filename.length > 15 ? '...' : ''}
                                                            </p>
                                                        ) : null}

                                                        {filename ? (
                                                            isfileInvalid && isfileInvalid.length > 0 ? (
                                                                <p className="noteCss">Note: {isfileInvalid}</p>
                                                            ) : (
                                                                    ''
                                                                )
                                                        ) : null}
                                                    </DialogContent>
                                                    {/* <p className="fileNameRed">{isfileInvalid}</p> */}
                                                    <p className="fileNameGreen">{uploadSuccessfully}</p>
                                                    <DialogActions className="paddingBtm txtCenter">
                                                        <Button
                                                            className="btnBluepop"
                                                            onClick={(e) => fileUpload(e)}
                                                            variant="contained"
                                                            disabled={uploadDisable}
                                                            component="label"
                                                            color="default"
                                                        >
                                                            Upload
                                                        </Button>
                                                        <Button
                                                            className="btnBluepop"
                                                            disabled={uploadSuccessfully.length}
                                                            onClick={closeDialog}
                                                            variant="contained"
                                                            component="label"
                                                            color="default"
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                            <div className="footer-button">
                                {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
                                <ul>
                                    <li>
                                        <Button
                                            color="primary"
                                            className="buttonnext txt-cap"
                                            onClick={() => {
                                                navigateBack();
                                            }}
                                            disabled={buttonDisable(stageId, userType.value)}
                                        >
                                            Back
                                        </Button>
                                    </li>

                                    {(AttachedITRAcknowledgementFilename && AttachedITRAcknowledgementFilename.length > 1) ||
                                        (offlineITRFilename && mailBtn) ? (
                                            <BootstrapTooltip
                                                title={
                                                    <React.Fragment>
                                                        <Typography color="inherit" className={classes.toolTipFont}>
                                                            {radioValue === 'offline'
                                                                ? paidTax === false
                                                                    ? 'After attaching Tax Challan and ITR acknowledgement, click on Send to Client and ITR Filed to intimate to client.'
                                                                    : 'After attaching ITR acknowledgement, click on ITR Filed to intimate to client.'
                                                                : 'After attaching ITR acknowledgement, click on ITR Filed to intimate to client.'}
                                                        </Typography>
                                                    </React.Fragment>
                                                }
                                            >
                                                <li>
                                                    <Button
                                                        color="primary"
                                                        className={'buttonnext txt-cap'}
                                                        disabled={
                                                            usertype === 'EM'
                                                                ? buttonDisable(stageId, userType.value)
                                                                : usertype === 'Other employee users'
                                                        }
                                                        onClick={handleNavigate}
                                                    >
                                                        Generate Report
                                                </Button>
                                                </li>
                                            </BootstrapTooltip>
                                        ) : (
                                            ''
                                        )}
                                </ul>
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
}
